import { useEffect, useState } from 'react';

/**
 * Hook to detect if viewport is at or above Tailwind's md breakpoint (>=768px) with SSR guards.
 * Subscribes to matchMedia changes so it updates on resize.
 */
export function useIsMdUp(): boolean {
  const [isMdUp, setIsMdUp] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(min-width: 768px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia('(min-width: 768px)');
    const onChange = (e: MediaQueryListEvent) => setIsMdUp(e.matches);
    // Set initial
    setIsMdUp(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMdUp;
}
